import React, { forwardRef } from 'react';
import { Button as PRButton } from 'primereact/button';
import { twJoin, twMerge } from 'tailwind-merge';
import spinner from '@/assets/spinner-blue.gif';

const variants = {
  primary:
    'bg-brand-ai-100 text-white hover:bg-brand-ai-hover-100 disabled:bg-pv-neutral-grey-100 disabled:text-pv-neutral-grey-300 disabled:cursor-not-allowed',
  ghost:
    'bg-transparent hover:bg-pv-neutral-grey-50 text-pv-neutral-grey-600 disabled:bg-transparent disabled:text-pv-neutral-grey-300 disabled:cursor-not-allowed active:text-pv-neutral-grey-300 active:bg-transparent',
  secondary:
    'bg-transparent hover:bg-brand-ai-gray-500 border border-brand-ai-100 text-brand-ai-100 disabled:bg-brand-ai-gray-400 disabled:border-brand-ai-gray-400 disabled:text-brand-ai-1000 disabled:cursor-not-allowed active:text-pv-primary-primary-300 active:bg-pv-primary-primary-50 active:border-pv-primary-primary-100',
  'ghost-blue':
    'bg-transparent text-brand-ai-100 hover:bg-pv-primary-primary-50 hover:text-pv-primary-primary-800 disabled:text-pv-primary-primary-300 disabled:bg-transparent disabled:cursor-not-allowed active:text-pv-primary-primary-300 active:bg-transparent',
};

const sizes = {
  small: 'px-2 py-1.5 text-1xs h-7',
  medium: 'px-3 py-1.5 text-xs h-8',
  large: 'px-3 py-2 text-sm',
};

const Button = forwardRef(function Button(
  {
    children,
    className,
    variant = 'ghost',
    size = 'small',
    leftElem,
    rightElem,
    isLoading,
    loadingText,
    ...props
  },
  ref
) {
  return (
    <PRButton
      pt={{
        root: {
          className: twMerge(
            'flex items-center justify-center cursor-pointer rounded-lg shadow-none opacity-100',
            variants[variant],
            sizes[size],
            twJoin(className?.button?.root && className.button.root)
          ),
        },
      }}
      ref={ref}
      {...props}
    >
      {isLoading ? (
        <>
          <img src={spinner} className="mr-2.5" width={16} height={16} />
          {loadingText}
        </>
      ) : (
        <>
          {leftElem && <span className="mr-1.5">{leftElem}</span>}
          {children}
          {rightElem && <span className="ml-1.5">{rightElem}</span>}
        </>
      )}
    </PRButton>
  );
});

export default Button;
